import { TimetableVersion } from '../TimetableVersionsOverview/TimetableVersionsOverview';

export type VersionTreeRow = {
  version: TimetableVersion;
  /**
   * Ein Eintrag pro Einrückungsebene. `true` = auf dieser Ebene folgt noch ein Geschwister-Knoten
   * (Linie wird durchgezogen), `false` = letztes Kind (Eckverbinder). Länge == Tiefe im Baum.
   */
  prefix: boolean[];
  hasChildren: boolean;
};

/**
 * Bringt die (nicht-Snapshot) Versionen in eine hierarchische Reihenfolge:
 * Kinder folgen direkt auf ihre Eltern. Versionen, deren Eltern nicht in der Liste sind
 * (z. B. ein Snapshot), werden als Wurzeln behandelt. Die aktive Version bleibt an ihrer
 * natürlichen Position im Baum und wird lediglich farblich hervorgehoben.
 */
export function buildVersionTree(versions: TimetableVersion[]): VersionTreeRow[] {
  const uuidSet = new Set(versions.map((v) => v.uuid));
  const childrenByParent = new Map<string, TimetableVersion[]>();
  const roots: TimetableVersion[] = [];

  versions.forEach((version) => {
    if (version.parentUuid && uuidSet.has(version.parentUuid)) {
      const siblings = childrenByParent.get(version.parentUuid) ?? [];
      siblings.push(version);
      childrenByParent.set(version.parentUuid, siblings);
    } else {
      roots.push(version);
    }
  });

  const rows: VersionTreeRow[] = [];
  const visit = (version: TimetableVersion, prefix: boolean[]) => {
    const children = childrenByParent.get(version.uuid) ?? [];
    rows.push({ version, prefix, hasChildren: children.length > 0 });
    children.forEach((child, index) => visit(child, [...prefix, index < children.length - 1]));
  };
  roots.forEach((root) => visit(root, []));

  return rows;
}
